import { render, staticRenderFns } from "./activity-user-list.vue?vue&type=template&id=b67d3a9a&scoped=true&"
import script from "./activity-user-list.vue?vue&type=script&lang=js&"
export * from "./activity-user-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-user-list.vue?vue&type=style&index=0&id=b67d3a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67d3a9a",
  null
  
)

export default component.exports